// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderArticlesListContainer_container__bEUFR","title":"OrderArticlesListContainer_title__pbDdL","list":"OrderArticlesListContainer_list__9XjjP"};